import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconWidgetHouse = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      className="block w-full h-full"
      fill="none"
      stroke="currentColor"
    >
      <path
        d="M5 20L8.33333 16.6667M8.33333 16.6667L20 5L31.6667 16.6667M8.33333 16.6667V33.3333C8.33333 34.2538 9.07953 35 10 35H15M31.6667 16.6667L35 20M31.6667 16.6667V33.3333C31.6667 34.2538 30.9205 35 30 35H25M15 35C15.9205 35 16.6667 34.2538 16.6667 33.3333V26.6667C16.6667 25.7462 17.4129 25 18.3333 25H21.6667C22.5871 25 23.3333 25.7462 23.3333 26.6667V33.3333C23.3333 34.2538 24.0795 35 25 35M15 35H25"
        stroke="#1A202C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  );

IconWidgetHouse.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconWidgetHouse;
